import { Check, X } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const ComparisonTable = () => {
  const features = [
    {
      feature: "Availability",
      virtual: "24/7/365",
      human: "40 hrs/week",
      service: "Limited hours",
      virtualBest: true,
    },
    {
      feature: "Scalability",
      virtual: "Instant",
      human: "Slow",
      service: "Limited",
      virtualBest: true,
    },
    {
      feature: "Training Required",
      virtual: "Once",
      human: "Ongoing",
      service: "None",
      virtualBest: false,
    },
    {
      feature: "Sick Days/Breaks",
      virtual: "Never",
      human: "Yes",
      service: "N/A",
      virtualBest: true,
    },
    {
      feature: "CRM Integration",
      virtual: "Full integration",
      human: "Manual entry",
      service: "Limited",
      virtualBest: true,
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-center text-2xl">
          Why Choose a Virtual Employee?
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left p-4 font-semibold">Feature</th>
                <th className="text-center p-4 font-semibold bg-primary/5">
                  Virtual Employee
                </th>
                <th className="text-center p-4 font-semibold">Human Employee</th>
                <th className="text-center p-4 font-semibold">Answering Service</th>
              </tr>
            </thead>
            <tbody>
              {features.map((item, index) => (
                <tr key={index} className="border-b hover:bg-muted/5">
                  <td className="p-4 font-medium">{item.feature}</td>
                  <td
                    className={`text-center p-4 ${
                      item.virtualBest ? "bg-primary/5 font-semibold" : ""
                    }`}
                  >
                    {item.virtualBest && (
                      <Check className="inline h-5 w-5 text-green-500 mr-2" />
                    )}
                    {item.virtual}
                  </td>
                  <td className="text-center p-4 text-muted-foreground">
                    {item.human}
                  </td>
                  <td className="text-center p-4 text-muted-foreground">
                    {item.service}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComparisonTable;
